import React from "react";
import "./PaymentSuccess.css";
import successImg from "../../assets/images/success.png";
import { Link } from "react-router-dom";
export function PaymentSuccess(){
    return(
        <div className="paymentSuccessBg">
          <div className="container success-container">
            <div className="payment-content">
                <div className="paymentImg"><img src={successImg}/></div>
                <div className="payment-title">Payment Successfull</div>
                <div className="payment-subtitle">Your payment has been completed.</div>
                <div className="btnPaymentBack"><Link to="/matchmakers"><button>Back</button></Link></div>

            </div>



          </div>
        </div>
    )
}